import { useRef } from "react";
import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import { Col, Row } from "antd";
import CustomButton from "components/common/Button";
import Colors from "assets/Colors";
import useStores from "graphql/useStores";
import ReactToPrint from "react-to-print";
import useZReportItems from "graphql/useZReportItems";
import moment from "moment";
import { formatPhoneNumberIntl } from "react-phone-number-input";
import { useTranslation } from "react-i18next";
import DocumentPDF from "../DocumentPDF";
import logo from "../../../../assets/images/logo.png";
import s from "../styles";
import useXReportItems from "graphql/useXReportItems";
import { useBusinessContext } from "../../../../BusinessApp";

function ContentBill({
  storeInfo,
  data,
  storeId,
  setconfirmationModal,
  visible,
}) {
  const { stores, loading: loadingStores } = useStores();
  const { t } = useTranslation();
  const { business, currencyFormat } = useBusinessContext();

  const store = stores.find((store) => store._id === data.storeId);

  const isTypeZ = data.type === "z";

  const {
    taxes: taxesz,
    subcategories: subcategoriesz,
    users: usersz,
    commissions: commissionsz,
    payments: paymentsz,
    withdrawals: withdrawalsz,
    loading: loadingz,
  } = useZReportItems(data);

  const {
    taxes: taxesx,
    subcategories: subcategoriesx,
    users: usersx,
    commissions: commissionsx,
    payments: paymentsx,
    withdrawals: withdrawalsx,
    loading: loadingx,
  } = useXReportItems(data);

  const subcategories = isTypeZ ? subcategoriesz : subcategoriesx;
  const taxes = isTypeZ ? taxesz : taxesx;
  const users = isTypeZ ? usersz : usersx;
  const commissions = isTypeZ ? commissionsz : commissionsx;
  const payments = isTypeZ ? paymentsz : paymentsx;
  const withdrawals = isTypeZ ? withdrawalsz : withdrawalsx;
  const loading2 = isTypeZ ? loadingz : loadingx;

  const loading = loading2 || loadingStores;

  const componentRef = useRef();

  const printDocument = async (
    data,
    storeInfo,
    storeId,
    orderItems,
    fileName
  ) => {
    const bill = await pdf(
      <DocumentPDF
        subcategories={subcategories}
        taxes={taxes}
        store={store}
        users={users}
        nif={business.idNumber}
        data={data}
        storeInfo={storeInfo}
        storeId={storeId}
        orderItems={orderItems}
        payments={payments}
        commissions={commissions}
        withdrawals={withdrawals}
        currencyFormat={currencyFormat}
      />
    ).toBlob();
    saveAs(bill, fileName);
    await setconfirmationModal(true);
  };

  return (
    <>
      <s.BillContainer ref={componentRef}>
        <s.logoPrint>
          <img width={100} src={logo} alt="logo" />
        </s.logoPrint>
        {store && (
          <s.headerDrawer style={{ marginBottom: "-10px" }}>
            <s.headerTitle>{store?.name}</s.headerTitle>
            <s.headerInfoCompany>{`NIF ${business?.idNumber}`}</s.headerInfoCompany>
            <s.headerInfoCompany>
              {store?.address1} {store?.zip && `,${store.zip}`}
            </s.headerInfoCompany>
            <s.headerInfoCompany>
              {store?.city}, {store?.country}
            </s.headerInfoCompany>
            <s.headerInfoCompany>
              {store?.phone && `${formatPhoneNumberIntl(store?.phone)}`}
            </s.headerInfoCompany>
          </s.headerDrawer>
        )}
        <s.divider
          style={{
            marginTop: "50px",
          }}
        />
        <s.headerDrawer
          style={{
            textAlign: "center",
            marginBottom: "0px",
            marginTop: "0px",
          }}
        >
          <s.subTitleBill>
            {t(`containers.Operations.Bill.${data.type}`)}
          </s.subTitleBill>
        </s.headerDrawer>
        <s.divider />
        <s.contentBill
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <s.pBill>{t("containers.Operations.Bill.date")}</s.pBill>
          <s.pBill>
            {moment(data?.creationDatetime).format("dddd, LL, h:mm a")}
          </s.pBill>
        </s.contentBill>
        <s.contentBill
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <s.pBill>{t("containers.Operations.Bill.employee")}</s.pBill>
          <s.pBill>{data?.openUserName}</s.pBill>
        </s.contentBill>
        <s.contentBill
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <s.pBill>{t("containers.Operations.Bill.number")}</s.pBill>
          <s.pBill>{data?.reportNumber}</s.pBill>
        </s.contentBill>
        <s.contentBill
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <s.pBill>{t("containers.Operations.Bill.terminalNumber")}</s.pBill>
          <s.pBill>{data?.terminalSerial}</s.pBill>
        </s.contentBill>
        <s.contentBill
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <s.pBill>{t("containers.Operations.Bill.close")}</s.pBill>
          <s.pBill>
            {moment(data?.closeDatetime || data?.updateDatetime).format(
              "dddd, LL, h:mm a"
            )}
          </s.pBill>
        </s.contentBill>
        <s.contentBill
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <s.pBill>{t("containers.Operations.Bill.open")}</s.pBill>
          <s.pBill>
            {moment(data?.creationDatetime).format("dddd, LL, h:mm a")}
          </s.pBill>
        </s.contentBill>
        {/* ************* */}
        <s.divider />
        <Row style={{ marginBottom: "11px" }}>
          <Col span={10}>
            <s.subTitleBill>
              {t("containers.Operations.Bill.description")}
            </s.subTitleBill>
          </Col>
          <Col span={7}>
            <s.subTitleBill>
              {t("containers.Operations.Bill.quantity")}
            </s.subTitleBill>
          </Col>
          <Col span={7} align="end">
            <s.subTitleBill>
              {t("containers.Operations.Bill.subTotal")}
            </s.subTitleBill>
          </Col>
        </Row>
        <s.divider />
        <Row>
          <Col span={10}>
            <s.pBill>{t("containers.Operations.Bill.totalItems")}</s.pBill>
          </Col>
          <Col span={7}>
            <s.pBill>{parseInt(data?.itemQuantity)}</s.pBill>
          </Col>
        </Row>
        <Row>
          <Col span={10}>
            <s.pBill>
              {t("containers.Operations.Bill.totalItemsReturned")}
            </s.pBill>
          </Col>
          <Col span={7}>
            <s.pBill>{parseInt(data?.itemRefundQuantity)}</s.pBill>
          </Col>
        </Row>
        <Row>
          <Col span={10}>
            <s.pBill>{t("containers.Operations.Bill.salesoperations")}</s.pBill>
          </Col>
          <Col span={1}>
            <s.pBill>{data?.facQuantity}</s.pBill>
          </Col>
        </Row>
        <Row>
          <Col span={10}>
            <s.pBill>{t("containers.Operations.Bill.returns")}</s.pBill>
          </Col>
          <Col span={7}>
            <s.pBill>{parseInt(data?.creQuantity)}</s.pBill>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <s.pBill>{t("containers.Operations.Bill.grossSales")}</s.pBill>
          </Col>
          <Col span={12} align="end">
            <s.pBill>
              {currencyFormat(
                (
                  parseFloat(data.facTotal) - parseFloat(data.creTotal) || 0
                ).toFixed(2)
              )}
            </s.pBill>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <s.pBill>{t("containers.Operations.Bill.netSales")}</s.pBill>
          </Col>
          <Col span={12} align="end">
            <s.pBill>
              {currencyFormat(
                (
                  parseFloat(taxes[0]?.amount2 || 0) +
                    parseFloat(taxes[1]?.amount2 || 0) +
                    parseFloat(taxes[2]?.amount2 || 0) +
                    parseFloat(taxes[3]?.amount2 || 0) || 0
                ).toFixed(2)
              )}
            </s.pBill>
          </Col>
        </Row>

        {taxes.map((tax) => (
          <div key={tax._id}>
            <Row>
              <Col span={12}>
                <s.pBill>
                  {tax.description.includes("EXENTO")
                    ? tax.description.split(" ")[1]
                    : `${t(
                        "containers.Operations.Bill.taxBase"
                      )} ${tax?.description.match(/(\d+)/g)}%`}
                  {/* {t("containers.Operations.Bill.taxBase")}{" "}
                  {tax?.description.match(/(\d+)/g)}% */}
                </s.pBill>
              </Col>
              <Col span={12} align="end">
                <s.pBill>{currencyFormat(tax.amount2)}</s.pBill>
              </Col>
            </Row>

            <Row>
              <Col span={12}>
                <s.pBill>{tax?.description}</s.pBill>
              </Col>
              <Col span={12} align="end">
                <s.pBill> {currencyFormat(tax?.amount)}</s.pBill>
              </Col>
            </Row>
          </div>
        ))}

        {/* **** */}
        <s.divider />
        {payments.map((payment) => {
          return (
            <Row key={payment._id}>
              <Col span={10}>
                <s.pBill>
                  {t(`containers.Operations.Bill.${payment.code}`)}
                </s.pBill>
              </Col>
              <Col span={7}>
                <s.pBill>{payment?.quantity}</s.pBill>
              </Col>
              <Col span={7} align="end">
                <s.pBill>{currencyFormat(payment?.amount)}</s.pBill>
              </Col>
            </Row>
          );
        })}
        <div
          style={{
            height: "25px",
          }}
        />

        <Row>
          <Col span={10}>
            <s.pBill>{t("containers.Operations.Bill.discount")}</s.pBill>
          </Col>
          <Col span={7}>
            <s.pBill>{parseFloat(data?.discountQuantity)}</s.pBill>
          </Col>
          <Col span={7} align="end">
            <s.pBill>{currencyFormat(data?.discountAmount)}</s.pBill>
          </Col>
        </Row>
        <Row>
          <Col span={10}>
            <s.pBill>
              {t("containers.Operations.Bill.quantityDiscountsReturned")}
            </s.pBill>
          </Col>
          <Col span={7}>
            <s.pBill>{parseFloat(data?.discountRefundQuantity)}</s.pBill>
          </Col>
          <Col span={7} align="end">
            <s.pBill>{currencyFormat(data?.discountRefundAmount)}</s.pBill>
          </Col>
        </Row>
        <s.divider />

        {subcategories.map((category, index) => {
          return (
            <div key={category._id}>
              <Row>
                <Col span={10}>
                  <s.pBill>{category?.description}</s.pBill>
                </Col>
                <Col span={7}>
                  <s.pBill>{category?.quantity}</s.pBill>
                </Col>
                <Col span={7} align="end">
                  <s.pBill>{currencyFormat(category?.amount)}</s.pBill>
                </Col>
              </Row>

              {parseInt(category?.quantity2) > 0 && (
                <Row>
                  <Col span={10}>
                    <s.pBill>
                      {" "}
                      {t("containers.Operations.Bill.returns")}{" "}
                      {category?.description}
                    </s.pBill>
                  </Col>
                  <Col span={7}>
                    <s.pBill>{category?.quantity2}</s.pBill>
                  </Col>
                  <Col span={7} align="end">
                    <s.pBill>{currencyFormat(category?.amount2)}</s.pBill>
                  </Col>
                </Row>
              )}
              {index === subcategories.length - 1 && <s.divider />}
            </div>
          );
        })}
        {/* ******************* */}
        {users.map((user, index) => {
          return (
            <div key={user._id}>
              {parseInt(user.quantity) !== 0 && (
                <Row>
                  <Col span={10}>
                    <s.pBill>{user.description}</s.pBill>
                  </Col>
                  <Col span={7}>
                    <s.pBill>{user.quantity}</s.pBill>
                  </Col>
                  <Col span={7} align="end">
                    <s.pBill>{currencyFormat(user?.amount)}</s.pBill>
                  </Col>
                </Row>
              )}

              {parseInt(user.quantity2) !== 0 && (
                <Row>
                  <Col span={10}>
                    <s.pBill>
                      {t("containers.Operations.Bill.discount")}{" "}
                      {user.description}
                    </s.pBill>
                  </Col>
                  <Col span={7}>
                    <s.pBill>{user.quantity2}</s.pBill>
                  </Col>
                  <Col span={7} align="end">
                    <s.pBill>{currencyFormat(user?.amount2)}</s.pBill>
                  </Col>
                </Row>
              )}

              {parseInt(user.quantity3) !== 0 && (
                <Row>
                  <Col span={10}>
                    <s.pBill>
                      {t("containers.Operations.Bill.returns")}{" "}
                      {user.description}
                    </s.pBill>
                  </Col>
                  <Col span={7}>
                    <s.pBill>{user.quantity3}</s.pBill>
                  </Col>
                  <Col span={7} align="end">
                    <s.pBill>{currencyFormat(user?.amount3)}</s.pBill>
                  </Col>
                </Row>
              )}

              {index === users.length - 1 && <s.divider />}
            </div>
          );
        })}

        {/* ************** */}
        {commissions.length > 0 && (
          <>
            <s.subTitleBill style={{ textAlign: "start" }}>
              {t("containers.Operations.Bill.commissions")}
            </s.subTitleBill>

            {commissions.map((commission, i) => (
              <div key={commission._id}>
                <Row>
                  <Col span={10}>
                    <s.pBill>{commission.description}</s.pBill>
                  </Col>
                  <Col span={7}>
                    <s.pBill>{commission.quantity}</s.pBill>
                  </Col>
                  <Col span={7} align="end">
                    <s.pBill>{currencyFormat(commission.amount)}</s.pBill>
                  </Col>
                </Row>

                {i === commissions.length - 1 && <s.divider />}
              </div>
            ))}
          </>
        )}
        {/* ******************* */}
        <Row>
          <Col span={12}>
            <s.pBill>{t("containers.Operations.Bill.invoicesFT")}</s.pBill>
          </Col>
          <Col span={12} align="end">
            <s.pBill>{`${data.facStartNumber} - ${data?.facEndNumber} `}</s.pBill>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <s.pBill>{t("containers.Operations.Bill.returnNC")}</s.pBill>
          </Col>
          {data?.creStartNumber && data?.creEndNumber ? (
            <Col span={12} align="end">
              <s.pBill>
                {`${
                  data?.creStartNumber == null
                    ? ""
                    : `${data?.creStartNumber} - `
                } ${data?.creEndNumber == null ? "" : data?.creEndNumber}`}
              </s.pBill>
            </Col>
          ) : (
            <Col span={12} align="end">
              <s.pBill>{t("containers.Operations.Bill.noEmitted")}</s.pBill>
            </Col>
          )}
        </Row>
        <s.divider />
        {/* ******************* */}
        <s.pBill style={{ textAlign: "center" }}>
          {t("containers.Operations.Bill.TransactionConsolidation")}
        </s.pBill>
        <s.divider />
        {/* ******************* */}
        <s.subTitleBill style={{ textAlign: "start" }}>
          {t("containers.Operations.Bill.cash")}
        </s.subTitleBill>
        <Row>
          <Col span={12}>
            <s.pBill>{t("containers.Operations.Bill.initialCash")}</s.pBill>
          </Col>
          <Col span={12} align="end">
            <s.pBill>{currencyFormat(data?.cashStartAmount)}</s.pBill>
          </Col>
        </Row>
        {/* **************** */}
        {withdrawals.map((withdrawal, i) => (
          <div key={withdrawal._id}>
            <Row>
              <Col span={12}>
                <s.pBill>
                  {t(`containers.Operations.Bill.${withdrawal.type}`)}
                  {withdrawal.description && ` - ${withdrawal.description}`}
                  {withdrawal.groupDescription &&
                    ` - ${withdrawal.groupDescription}`}
                </s.pBill>
              </Col>
              <Col span={12} align="end">
                <s.pBill>{currencyFormat(withdrawal?.amount)}</s.pBill>
              </Col>
            </Row>
            {i === withdrawals.length - 1 && <s.divider />}
          </div>
        ))}
        {/* ***************** */}
        <Row>
          <Col span={12}>
            <s.pBill>{t("containers.Operations.Bill.cash_end")}</s.pBill>
          </Col>
          <Col span={12} align="end">
            <s.pBill>
              {currencyFormat(
                parseFloat(data?.cashStartAmount) + parseFloat(data?.cashAmount)
              )}
            </s.pBill>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <s.pBill>{t("containers.Operations.Bill.finalCash")}</s.pBill>
          </Col>
          <Col span={12} align="end">
            <s.pBill>{currencyFormat(data?.cashEndAmount)}</s.pBill>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <s.pBill>{t("containers.Operations.Bill.difference")}</s.pBill>
          </Col>
          <Col span={12} align="end">
            <s.pBill>
              {currencyFormat(
                data?.cashEndAmount -
                  (parseFloat(data?.cashStartAmount) +
                    parseFloat(data?.cashAmount))
              )}
            </s.pBill>
          </Col>
        </Row>
      </s.BillContainer>
      {visible && (
        <s.containerButton>
          <CustomButton
            disabled={loading}
            style={{
              color: Colors.primary,
              width: "169px",
              fontWeight: "500",
              borderRadius: "5px",
              height: "40px",
              marginRight: "20px",
            }}
            onClick={() =>
              printDocument(
                data,
                storeInfo,
                taxes,
                storeId,
                `${t("containers.Operations.Bill.close#")} ${
                  data?.type
                } #${parseInt(data?.reportNumber)}`
              )
            }
          >
            {t("containers.Operations.Bill.dowmload")}
          </CustomButton>

          <ReactToPrint
            trigger={() => (
              <CustomButton
                disabled={loading}
                style={{
                  background: Colors.primary,
                  color: Colors.text_on_secondary,
                  width: "169px",
                  fontWeight: "500",
                  border: "none",
                  borderRadius: "5px",
                  height: "40px",
                }}
              >
                {t("containers.Operations.Bill.print")}
              </CustomButton>
            )}
            content={() => componentRef.current}
          />
        </s.containerButton>
      )}
    </>
  );
}

export default ContentBill;
